<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
      <section id="ngx-datatable-kitchen-sink">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">{{ 'MENU.DASHBOARD.contracts' | translate }}</h4>
            <!-- <button class="btn btn-primary" (click)="addCoupon()">
              Add Employees
            </button> -->
          </div>
          <div class="card-body">
            <p class="card-text">{{ 'MENU.DASHBOARD.contracts_list' | translate }}</p>
          </div>
        </div>
  
        <div class="row d-flex justify-content-between">
          <div class="col-md-2 col-sm-12 mb-1 mb-md-0">
            <div class="form-group">
              <label for="itemsPerPage"  style="margin-right:6px !important">{{ 'MENU.DASHBOARD.show' | translate }}</label>
              <div class="d-flex align-items-center">
                <select
                  id="itemsPerPage"
                  class="form-control form-control-sm "
                  [(ngModel)]="itemsPerPage"
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <span class="mx-1">{{ 'MENU.DASHBOARD.entries' | translate }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="searchInput" class="mr-2">{{ 'MENU.DASHBOARD.search' | translate }}</label>
              <input
                id="searchInput"
                type="search"
                placeholder="{{ 'MENU.DASHBOARD.serial_number' | translate }}"
                class="form-control form-control-sm"
                (keyup)="filterUpdate($event)"
                (search)="filterUpdate($event)"
              />
            </div> 
          </div>
        </div>
  
        <ngx-datatable 
        [rows]="pages"
        [rowHeight]="58"
        class="bootstrap core-bootstrap bg-white"
        [limit]="itemsPerPage"
        [columnMode]="ColumnMode.force"
        [headerHeight]="40"
        [footerHeight]="50"
        [scrollbarH]="true"
          [messages]="messages"

      >
        <ngx-datatable-column
          name="{{ 'MENU.DASHBOARD.serial_number' | translate }}"
          prop="serial_number"
          [width]="200"
        ></ngx-datatable-column>
 <!-- 🧾 Contract Type -->
<ngx-datatable-column name="{{ 'MENU.DASHBOARD.contract_type' | translate }}" [width]="150">
  <ng-template ngx-datatable-cell-template let-row="row">
    {{ _translateService.currentLang === 'ar'
      ? row.contract_type?.name_ar
      : row.contract_type?.name_en }}
  </ng-template>
</ngx-datatable-column>

<!-- ⏱ Duration (Months) -->
<ngx-datatable-column name="{{ 'MENU.DASHBOARD.duration_months' | translate }}" [width]="150">
  <ng-template ngx-datatable-cell-template let-row="row">
    {{ row?.duration_text }}
  </ng-template>
</ngx-datatable-column>

<!-- 💰 Investment Amount -->
<ngx-datatable-column name="{{ 'MENU.DASHBOARD.investment_amount' | translate }}" [width]="180">
  <ng-template ngx-datatable-cell-template let-row="row">
    {{ row.investment_amount }}
  </ng-template>
</ngx-datatable-column>

<!-- 📊 Ratio -->
<ngx-datatable-column
  name="{{ 'MENU.DASHBOARD.Ratio' | translate }}"
  [width]="170"
>
  <ng-template ngx-datatable-cell-template let-row="row">
    <div *ngIf="row.installments?.length" class="w-100">
      <div class="progress" style="height: 8px;">
     <div
  class="progress-bar"
  role="progressbar"
  [class.bg-success]="getContractRatio(row) >= 75"
  [class.bg-warning]="getContractRatio(row) < 75 && getContractRatio(row) >= 40"
  [class.bg-danger]="getContractRatio(row) < 40"
  [style.width.%]="getContractRatio(row)"
></div>

      </div>
      <small class="text-muted">
        {{ getContractRatio(row) }}%
      </small>
    </div>

    <span *ngIf="!row.installments?.length">0%</span>
  </ng-template>
</ngx-datatable-column>


<!-- 📈 Investment Rate -->
<ngx-datatable-column name="{{ 'MENU.DASHBOARD.investment_rate_min' | translate }}" [width]="150">
  <ng-template ngx-datatable-cell-template let-row="row">
  {{row.investment_rate}} %
  </ng-template>
</ngx-datatable-column>
<!-- 📈 Investment Rate -->
<ngx-datatable-column name="{{ 'MENU.DASHBOARD.investment_rate_max' | translate }}" [width]="150">
  <ng-template ngx-datatable-cell-template let-row="row">
  {{row.investment_rate_max}} %
  </ng-template>
</ngx-datatable-column>

<!-- 💵 Profit Amount -->
<ngx-datatable-column name="{{ 'MENU.DASHBOARD.profit_amount' | translate }}" [width]="150">
  <ng-template ngx-datatable-cell-template let-row="row">
    {{ row.profit_amount }}
  </ng-template>
</ngx-datatable-column>

<ngx-datatable-column name="{{ 'MENU.DASHBOARD.profit_max' | translate }}" [width]="150">
  <ng-template ngx-datatable-cell-template let-row="row">
    {{ row.profit_max }}
  </ng-template>
</ngx-datatable-column>

<ngx-datatable-column name="{{ 'MENU.DASHBOARD.pdf' | translate }}" [width]="150">
  <ng-template ngx-datatable-cell-template let-row="row">
    <ng-container *ngIf="row?.pdf; else noPdf">
      <a 
        [href]="row.pdf" 
        target="_blank" 
        download
        class="text-primary text-decoration-underline"
      >
        {{ 'MENU.DASHBOARD.download_pdf' | translate }}
      </a>
    </ng-container>
    <ng-template #noPdf>
      <span class="text-muted">-</span>
    </ng-template>
  </ng-template>
</ngx-datatable-column>




<!-- ⚙️ Status -->
<ngx-datatable-column name="{{ 'MENU.DASHBOARD.status' | translate }}" [width]="120">
  <ng-template ngx-datatable-cell-template let-row="row">
    <span
     class="px-1 py-1 badge rounded-pill fw-semibold text-capitalize move"
     
  [ngStyle]="{
    'background-color':
      row.status === 'ended'
        ? 'rgba(108, 117, 125, 0.1)'
        : row.status === 'approved'
        ? 'rgba(25, 135, 84, 0.1)'
        : row.status === 'pending'
        ? 'rgba(255, 193, 7, 0.1)'
        : 'rgba(220, 53, 69, 0.1)',
    'color':
      row.status === 'ended'
        ? '#6c757d'
        : row.status === 'approved'
        ? '#198754'
        : row.status === 'pending'
        ? '#212529'
        : '#dc3545',
    'border': '1px solid ' + (
        row.status === 'ended'
          ? '#6c757d'
          : row.status === 'approved'
          ? '#198754'
          : row.status === 'pending'
          ? '#ffc107'
          : '#dc3545'
      )
  }"
>
  <i
    class="me-1"
     [ngClass]="{
                    'bg-warning': row.status === 'pending',
                    'bg-secondary': row.status === 'ended',
                    'bg-success': row.status === 'approved'
                  
                  }"
  ></i>
  {{ row.status_text }}
</span>
  </ng-template>
</ngx-datatable-column>



          <!-- Actions -->
<ngx-datatable-column name="{{ 'MENU.DASHBOARD.investor_actions' | translate }}" prop="actions" [flexGrow]="1" [sortable]="false">
  <ng-template ngx-datatable-cell-template let-row="row">
    <div class="d-flex align-items-center">
      <div ngbDropdown container="body" class="btn-group">
        <button
          ngbDropdownToggle
          type="button"
          class="btn btn-sm btn-icon dropdown-toggle hide-arrow"
          [id]="'dropdownActions_' + row.id"
        >
          <i data-feather="more-vertical"></i>
        </button>

        <div
          ngbDropdownMenu
          class="dropdown-menu dropdown-menu-right"
          [attr.aria-labelledby]="'dropdownActions_' + row.id"
        >

                       <!-- Edit Button -->
  <!-- <button
    class="dropdown-item text-primary w-100"
    ngbDropdownItem
    (click)="showTags(row.id)"
  >
    <i data-feather="eye" class="mr-50 mx-2"></i>
    {{ 'MENU.DASHBOARD.Show_Product_Tags' | translate }}
  </button> -->

  
  <!-- <button
  class="dropdown-item w-100"
  ngbDropdownItem
  (click)="viewDetails(row.id)"
>
  <i data-feather="eye" class="mr-50 mx-2"></i>
  {{ 'MENU.DASHBOARD.investor_details' | translate }}

</button> -->


     <!-- Edit Button -->
      <button
        class="dropdown-item w-100"
        ngbDropdownItem
        (click)="editProduct(row.id)"
      >
        <i data-feather="edit" class="mr-50 mx-2"></i>
        {{ 'MENU.DASHBOARD.investor_edit' | translate }}
      </button>

      <button
        *ngIf="row.status !== 'ended'"
        class="dropdown-item text-warning w-100"
        ngbDropdownItem
        (click)="confirmEndContract(row)"
      >
        <i data-feather="slash" class="mr-50 mx-2"></i>
        {{ 'MENU.DASHBOARD.END_CONTRACT' | translate }}
      </button>

          <button
            class="dropdown-item text-danger w-100"
            ngbDropdownItem
  (click)="confirmDelete(row.id)"
          >
            <i data-feather="trash" class="mr-50 mx-2"></i>
             {{ 'MENU.DASHBOARD.investor_delete' | translate }}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</ngx-datatable-column>



      </ngx-datatable>
       
      </section>
    </div>
  </div>
